<template>
  <div class="sub-form-textarea sub-columns">
    <BaseInput type="number" name="min value" :validate="minValidator" class="sub-col" v-model="form.min" label="Min characters length"/>
    <BaseInput type="number" name="max value" validate="required|integer|min_value:0" class="sub-col" v-model="form.max" label="Max characters length" hint="0 = unlimited number of characters"/>
    <BaseInput class="sub-w100" v-model="form.rows" label="Number of rows" hint="How tall this field should be while adding content."/>
  </div>
</template>

<script>
  import subformMixin from '@/mixins/sub-form.mixin'

  export default {
    mixins: [ subformMixin ],
    data () {
      return {
        form: {
          min: '0',
          max: '0',
          rows: '5'
        }
      }
    },
    computed: {
      minValidator () {
        return `required|integer|min_value:0|${this.form.max == 0 ? '' : '|max_value:' + this.form.max }`
      }
    }
  }
</script>

<style lang="scss">

  .sub-form-textarea {
    
  }
</style>


// WEBPACK FOOTER //
// src/components/forms/sub-forms/SubFormTextarea.vue